(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/triss.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/triss.js');

'use strict';

svs.numbergames.game.views.Triss = Marionette.View.extend({
  viewOptions: ['productId'],
  ui: {
    trissContainer: '.js-triss-container',
    trissCheckbox: '.js-triss',
    trissSyndicate: '.js-triss-syndicate',
    trissSubscription: '.js-triss-subscription'
  },
  modelEvents: {
    'change:isSyndicate': 'toggleClasses',
    'change:isSubscription': 'toggleClasses'
  },
  triggers: {
    'change @ui.trissCheckbox': 'changeTriss'
  },
  template(data) {
    return svs.numbergames.game.templates.triss(data);
  },
  templateContext() {
    return {
      text: this.trissModel.get('text'),
      imgUrl: this.trissModel.get('imgUrl'),
      skin: this.trissModel.get('skin'),
      quantity: this.trissModel.get('quantity')
    };
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
    this.trissModel = this.model.get('tickets').at(0);
    this.listenTo(this.trissModel, 'change:isDisabled', this.toggleClasses);
  },
  onAttach() {
    this.toggleClasses();
  },
  toggleClasses() {
    this.ui.trissContainer.toggleClass('active', !this.trissModel.get('isDisabled'));
    this.ui.trissSyndicate.toggleClass('triss-transform__show', this.model.get('isSyndicate'));
    this.ui.trissSubscription.toggleClass('triss-transform__show', this.model.get('isSubscription'));
    this.ui.trissCheckbox.prop('disabled', this.trissModel.get('isDisabled'));
  },
  onChangeTriss(view, event) {
    if (event.target.checked) {
      const label = "bet-".concat(this.productId.toLowerCase());
      svs.components.analytics.trackEvent({
        category: 'Add-on game',
        action: 'triss30',
        opt_label: label
      });
    }
    const quantity = event.target.checked && !this.trissModel.get('isDisabled') ? 1 : 0;
    this.trissModel.set({
      quantity
    });
    this.ui.trissContainer.toggleClass('checked', event.target.checked);
  }
});

 })(window);